import React, { useEffect, memo } from 'react';
import { useSelector } from 'react-redux';
import { capturePageLoadAnalytics } from '../../utils/analytics/analyticsDispatchers';
import { API_SYSTEM_ERROR_EVENT } from '../../utils/analytics/analyticsEvents';
import { getRetrieveAccountErrorContent } from '../../store/contentSlice';

const InlineLowesAccountError = memo(() => {
  const {
    heading,
    subHeading,
    contentTitle,
    contentLine1,
    contentLine2,
    contentLine3,
    contentLine4,
    contentLine5,
  }: any = useSelector((state: any) =>
    getRetrieveAccountErrorContent(state, 'lowes'),
  );
  useEffect(() => {
    capturePageLoadAnalytics(API_SYSTEM_ERROR_EVENT);
  }, []);

  return (
    <div className="error-inline-retrieve-message-content error-pg-message-content-desc">
      <div className="error-message-wrapper">
        <p className="error-pg-heading">{heading}</p>
        <p className="error-pg-message">{subHeading}</p>
        <div className="error-message-wrapper">
          <p className="error-pg-message-content">{contentTitle}</p>
          <div className="error-pg-message-content error-desc-bullet-pt">
            <ul className="list-disc">
              <li>
                <p>{contentLine1}</p>
              </li>
              <li>
                <p>{contentLine2}</p>
              </li>
              <li>
                <p>{contentLine3}</p>
              </li>
            </ul>
          </div>
          <p className="error-pg-message-content error-pg-message-content-desc">
            {contentLine4}
            {contentLine5}
          </p>
        </div>
      </div>
    </div>
  );
});

export default InlineLowesAccountError;
